/**
 * 记录的数据形状，与后端 normalizeRecord() 一一对应。
 * 后端会截断超长字段并补默认值，这里保持字段名一致即可，不要自创字段（会被丢弃）。
 */
export type BaziRecord = {
  id?: string;
  name?: string;
  type?: string;
  category?: string;
  sex?: string;
  calendar?: string;
  birthAt?: string;
  locationCity?: string;
  pillarInput?: string;
  solarTime?: boolean;
  summer?: boolean;
  midnight?: boolean;
  time?: string;
  lunar?: string;
  location?: string;
  /** 天干，年月日时四柱，最多 4 项 */
  tg?: string[];
  /** 地支，年月日时四柱，最多 4 项 */
  dz?: string[];
  tags?: string[];
  starred?: boolean;
  note?: string;
  createdAt?: string;
  updatedAt?: string;
  /** 后端内容审核结果，前端只读 */
  reviewStatus?: string;
  reviewReasons?: string[];
};

export type ChartResult = {
  pillars: { label: string; gan: string; zhi: string }[];
  lunarText: string;
  solarText: string;
  dayMaster: string;
};

/** 把排盘结果转成后端认识的记录结构。 */
export function chartToRecord(
  chart: ChartResult,
  input: { name: string; date: string; time: string; gender: "male" | "female" },
): BaziRecord {
  return {
    name: input.name.trim() || "未命名案例",
    type: "paipan",
    category: "全部",
    sex: input.gender === "male" ? "男" : "女",
    calendar: "公历",
    birthAt: `${input.date} ${input.time}`,
    time: input.time,
    lunar: chart.lunarText,
    pillarInput: chart.pillars.map((p) => `${p.gan}${p.zhi}`).join(" "),
    tg: chart.pillars.map((p) => p.gan),
    dz: chart.pillars.map((p) => p.zhi),
    tags: [],
    starred: false,
    note: "",
  };
}
